import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { Toaster } from './components/ui/toaster';

import Login from './pages/Login';
import Layout from './components/Layout';
import ProtectedRoute from './components/ProtectedRoute';
import Dashboard from './pages/Dashboard';
import Equipment from './pages/Equipment';
import Operators from './pages/Operators';
import EquipmentRequests from './pages/EquipmentRequests';
import Inspections from './pages/Inspections';
import Mobilizations from './pages/Mobilizations';
import MobilizationForm from './pages/MobilizationForm';
import PublicTracking from './pages/PublicTracking';
import EquipmentQueues from './pages/EquipmentQueues';
import Consumables from './pages/Consumables';
import SystemGuide from './pages/SystemGuide';
import TechnicalDoc from './pages/TechnicalDoc';
import Maintenance from './pages/Maintenance';
import Utilizations from './pages/Utilizations';
import Contracts from './pages/Contracts';
import Billings from './pages/Billings';
import Settings from './pages/Settings';
import Users from './pages/Users';
import Dropdowns from './pages/Dropdowns';
import AuditLogs from './pages/AuditLogs';
import DataManagement from './pages/DataManagement';
import Roles from './pages/Roles';
import ApprovalWorkflow from './pages/ApprovalWorkflow';
import Branding from './pages/Branding';
import SecuritySettings from './pages/SecuritySettings';

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            {/* Public tracking page – accessible via QR scan, no auth required */}
            <Route path="/track/:token" element={<PublicTracking />} />
            <Route element={<ProtectedRoute><Layout /></ProtectedRoute>}>
              <Route path="/" element={<Navigate to="/dashboard" replace />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/equipment" element={<Equipment />} />
              <Route path="/operators" element={<ProtectedRoute roles={['super_admin','admin','supervisor','approver']}><Operators /></ProtectedRoute>} />
              <Route path="/equipment-requests" element={<EquipmentRequests />} />
              <Route path="/inspections" element={<ProtectedRoute roles={['super_admin','admin','supervisor','approver']}><Inspections /></ProtectedRoute>} />
              <Route path="/equipment-queues" element={<ProtectedRoute roles={['super_admin','admin','supervisor','approver']}><EquipmentQueues /></ProtectedRoute>} />
              <Route path="/mobilizations" element={<Mobilizations />} />
              <Route path="/mobilizations/:id/form" element={<MobilizationForm />} />
              <Route path="/consumables" element={<Consumables />} />
              <Route path="/guide" element={<SystemGuide />} />
              <Route path="/maintenance" element={<ProtectedRoute roles={['super_admin','admin','supervisor']}><Maintenance /></ProtectedRoute>} />
              <Route path="/utilizations" element={<ProtectedRoute roles={['super_admin','admin','supervisor']}><Utilizations /></ProtectedRoute>} />
              <Route path="/contracts" element={<ProtectedRoute roles={['super_admin','admin']}><Contracts /></ProtectedRoute>} />
              <Route path="/billings" element={<ProtectedRoute roles={['super_admin','admin']}><Billings /></ProtectedRoute>} />
              <Route path="/settings" element={<ProtectedRoute roles={['super_admin','admin']}><Settings /></ProtectedRoute>}>
                <Route path="users" element={<ProtectedRoute roles={['super_admin','admin']}><Users /></ProtectedRoute>} />
                <Route path="roles" element={<ProtectedRoute roles={['super_admin']}><Roles /></ProtectedRoute>} />
                <Route path="approvals" element={<ProtectedRoute roles={['super_admin']}><ApprovalWorkflow /></ProtectedRoute>} />
                <Route path="dropdowns" element={<ProtectedRoute roles={['super_admin','admin']}><Dropdowns /></ProtectedRoute>} />
                <Route path="branding" element={<ProtectedRoute roles={['super_admin','admin']}><Branding /></ProtectedRoute>} />
                <Route path="security" element={<ProtectedRoute roles={['super_admin']}><SecuritySettings /></ProtectedRoute>} />
                <Route path="data" element={<ProtectedRoute roles={['super_admin']}><DataManagement /></ProtectedRoute>} />
                <Route path="audit-logs" element={<ProtectedRoute roles={['super_admin']}><AuditLogs /></ProtectedRoute>} />
                <Route path="tech-handbook" element={<ProtectedRoute roles={['super_admin']}><TechnicalDoc /></ProtectedRoute>} />
              </Route>
              {/* Legacy redirects */}
              <Route path="/docs/architecture" element={<Navigate to="/settings/tech-handbook" replace />} />
              <Route path="/users" element={<Navigate to="/settings/users" replace />} />
              <Route path="/dropdowns" element={<Navigate to="/settings/dropdowns" replace />} />
              <Route path="/audit-logs" element={<Navigate to="/settings/audit-logs" replace />} />
              <Route path="*" element={<Navigate to="/dashboard" replace />} />
            </Route>
          </Routes>
          <Toaster />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
